import { render, staticRenderFns } from "./InternaCategory.vue?vue&type=template&id=09c78308&scoped=true&"
import script from "./InternaCategory.vue?vue&type=script&lang=js&"
export * from "./InternaCategory.vue?vue&type=script&lang=js&"
import style0 from "./InternaCategory.vue?vue&type=style&index=0&id=09c78308&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09c78308",
  null
  
)

export default component.exports